import { render, staticRenderFns } from "./join-button.vue?vue&type=template&id=cb3c1e68&"
import script from "./join-button.vue?vue&type=script&lang=js&"
export * from "./join-button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports